import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexInvoiceTwo',
  setup(__props) {

const Card3 = defineAsyncComponent(() => import("@/components/common/card/CardData3.vue"))
const InvoicePageTwo = defineAsyncComponent(() => import("@/components/theme/ecommerce/invoice/invoice2/InvoicePageTwo.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "ECommerce",
      mains: "Invoice-2",
      title: "Invoice-2"
    }),
    _createVNode(_unref(Card3), { colClass: "container invoice-2" }, {
      default: _withCtx(() => [
        _createVNode(_unref(InvoicePageTwo))
      ]),
      _: 1
    })
  ], 64))
}
}

})